import { authFetch } from "../utils/authFetch"
import { API_BASE_URL } from "../config"

// URL base para la API del Calendario de Pagos (cobro del servicio a cada empresa)
const baseUrl = `${API_BASE_URL}/api/pagos-empresa`

// La empresa (clientes del servicio) se gestiona con la API existente de empresas
const empresasUrl = `${API_BASE_URL}/api/empresas`

/** Lista todos los ciclos de pago de todas las empresas. */
export const getPagos = async () => {
  const response = await authFetch(baseUrl, { method: "GET" })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al consultar los pagos: ${errorText || "Sin detalles"}`)
  }
  return response.json()
}

/** Lista los ciclos de pago de una empresa específica. */
export const getPagosPorEmpresa = async (idEmpresa) => {
  const response = await authFetch(`${baseUrl}/empresa/${idEmpresa}`, { method: "GET" })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al consultar los pagos de la empresa: ${errorText || "Sin detalles"}`)
  }
  return response.json()
}

/** Crea un nuevo ciclo de pago. */
export const createPago = async (pagoData) => {
  const response = await authFetch(baseUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(pagoData),
  })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al crear el pago: ${errorText || "Sin detalles"}`)
  }
  return response.json()
}

/** Actualiza un ciclo de pago existente. */
export const updatePago = async (id, pagoData) => {
  const response = await authFetch(`${baseUrl}/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(pagoData),
  })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al actualizar el pago: ${errorText || "Sin detalles"}`)
  }
  return response.json()
}

/** Cambia solo el estado (PENDIENTE | RENOVADO | NO_RENOVO). */
export const updateEstadoPago = async (id, estado) => {
  const response = await authFetch(`${baseUrl}/${id}/estado`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ estado }),
  })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al cambiar el estado: ${errorText || "Sin detalles"}`)
  }
  return response.json()
}

/** Elimina un ciclo de pago. */
export const deletePago = async (id) => {
  const response = await authFetch(`${baseUrl}/${id}`, { method: "DELETE" })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al eliminar el pago: ${errorText || "Sin detalles"}`)
  }
  return { success: true }
}

/**
 * Envío MANUAL del recordatorio de un pago (botón "Notificar").
 * Fuerza el envío aunque ya se haya notificado antes.
 */
export const notificarPago = async (id) => {
  const response = await authFetch(`${baseUrl}/${id}/notificar`, { method: "POST" })
  const data = await response.json().catch(() => ({}))
  if (!response.ok) {
    throw new Error(data.mensaje || data.error || "No se pudo enviar el recordatorio.")
  }
  return data
}

/**
 * Dispara la revisión de vencimientos + envío de recordatorios (n8n).
 * Se llama al abrir el calendario. No interrumpe la carga si falla.
 */
export const revisarVencimientos = async () => {
  try {
    const response = await authFetch(`${baseUrl}/revisar-vencimientos`, { method: "POST" })
    if (!response.ok) return { recordatoriosEnviados: 0 }
    return response.json()
  } catch (e) {
    return { recordatoriosEnviados: 0 }
  }
}

/** Lista las empresas (para el selector al crear/editar un pago). */
export const getEmpresas = async () => {
  const response = await authFetch(empresasUrl, { method: "GET" })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al consultar las empresas: ${errorText || "Sin detalles"}`)
  }
  return response.json()
}
